module.exports = __webpack_public_path__ + "static/media/camperj.7b49991c.svg";